import React from 'react';


const Start = () => <div>start screen wooo</div>;

export default Start;



// WEBPACK FOOTER //
// ./src/Start.js